<template>
  <div class="commonTitle3">
    <div class="commonTitle3-back">
      <img v-if="showBack" @click="goBack()" src="../assets/public/chevron-right.svg" alt="">
    </div>
    <div class="commonTitle3-title">
      <slot name="titleText"></slot>
    </div>
    <div class="empty-r">
      <slot name="titleRight"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonTitle3',
  props: {
    showBack: {
      type: Boolean,
      default: true
    },
    customGoBack: null
  },
  methods: {
    goBack() {
      if (this.customGoBack) {
        this.customGoBack()
      } else {
        this.$router.go(-1)
      }
      // if (this.customGoBack) {
      //   this.$emit("goBack");
      // } else {
      //   this.$router.go(-1)
      // }
    }
  },
}
</script>

<style lang="scss" scoped>
.commonTitle3 {
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFang SC, PingFang SC;

  &-back {
    cursor: pointer;
    width: 4.4rem;
    height: 2.4rem;
    display: flex;
    align-items: center;
    justify-content: center;

    &>img {
      display: block;
      width: 2.4rem;
      height: 2.4rem;
    }
  }

  &-title {
    font-weight: 600;
    font-size: 1.6rem;
    color: #000000;
    line-height: 2rem;
  }

  .empty-r {
    width: 4.4rem;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commonTitle3.vue